var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIChargingCableSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,8h-1V2h-2v6h-4V2h-2v6h-1c-1.1025391,0-2,0.8974609-2,2v8c0,1.1025391,0.8974609,2,2,2h4v1c0,4.9628906-4.0371094,9-9,9 s-9-4.0371094-9-9V11c0-4.9628906,4.0371094-9,9-9V0C6.9345703,0,2,4.9345703,2,11v10c0,6.0654297,4.9345703,11,11,11 s11-4.9345703,11-11v-1h4c1.1025391,0,2-0.8974609,2-2v-8C30,8.8974609,29.1025391,8,28,8z M18,18v-8h10l0.0019531,8H18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIChargingCableSmall);
export default __webpack_public_path__ + "static/media/i-charging-cable--small.56b028ff21248638ec9882fa59c03981.svg";
export { ForwardRef as ReactComponent };